import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Target, Sparkle } from "@phosphor-icons/react";

export default function ThisWeekHero({ week, currentWeekNum }) {
  if (!week) return null;
  const heroBg =
    "https://static.prod-images.emergentagent.com/jobs/2d9c142e-ed55-40de-ac53-c13d9c2402dc/images/667d272cc959be0443256e780b204d23b6ef7ee8ecd743f7da322b5ccf810734.png";

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="relative rounded-3xl overflow-hidden shadow-sm hero-grain"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(15,23,42,0.78), rgba(15,23,42,0.55)), url(${heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="this-week-hero"
    >
      <div className="relative p-6 sm:p-10 text-white">
        <div className="flex items-center gap-2 mb-4">
          <span className="px-3 py-1 text-xs font-bold tracking-wider uppercase rounded-full bg-yellow-400 text-yellow-950">
            This Week · Week {week.week_num}
          </span>
          <span className="text-xs text-white/70">{week.category}</span>
        </div>

        <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight max-w-3xl">
          {week.title}
        </h1>
        <p className="font-caveat text-2xl sm:text-3xl text-yellow-300 mt-2">{week.tagline}</p>

        <p className="mt-5 text-white/85 max-w-2xl text-base leading-relaxed">{week.core_concept}</p>

        <div className="mt-6 flex flex-wrap gap-3">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur px-3 py-2 rounded-xl text-sm">
            <Clock size={16} weight="bold" /> {week.duration}
          </div>
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur px-3 py-2 rounded-xl text-sm">
            <Target size={16} weight="bold" /> {week.tasks?.length || 0} tasks
          </div>
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur px-3 py-2 rounded-xl text-sm">
            <Sparkle size={16} weight="fill" /> {week.sessions?.length || 0} sessions
          </div>
        </div>

        <div className="mt-8">
          <Link
            to={`/week/${week.week_num}`}
            data-testid="hero-open-week-link"
            className="btn-tactile-yellow inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-yellow-400 text-yellow-950 font-outfit font-bold hover:bg-yellow-500"
          >
            Open this week's plan <ArrowRight weight="bold" size={18} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
